
import { ActionList, ActionMenu } from '@primer/react';
import { useMemo } from 'react';

type CmbHinhThucNopPhiProps = {
	isReadonly?: boolean;
	value?: number;
	onValueChanged: (id: number, data?: any) => void;
	className?: string;
	isShowClearButton?: boolean;
	preText?: string;
	width?: string | number;
	dm_truong_id?: number;
	stylingMode?: 'outlined' | 'filled' | 'underlined';
	size?: "small" | "medium" | "large" 
};

const kyNops = [
    { id: 10, text: "Theo năm" },
    { id: 5,  text: "Theo kỳ" },
    { id: 13, text: "Theo tháng" },
];

const CmbHinhThucNopPhi = (props: CmbHinhThucNopPhiProps) => {
	const source = useMemo(() => {
		return kyNops;
	}, []);

	const selectedData = useMemo(() => {
		if (props.value) {
			return source.find(x => x.id === props.value)
		}
		return undefined
	}, [source, props.value])

	return (

		<div style={{ width: '100%' }}>
			<ActionMenu>
				<ActionMenu.Button
					aria-label="Select school year"
					size={props.size}
					style={{
						width: '100%',
						display: 'flex',
						justifyContent: 'space-between'
					}}
				>
					{selectedData ? selectedData.text : "Chọn hình thức nộp phí"}
				</ActionMenu.Button>
				<ActionMenu.Overlay width="small">
					<ActionList selectionVariant="single">
						{props.isShowClearButton &&
							<ActionList.Item key={0} selected={props.value != undefined && 0 === props.value}
								onSelect={() => {
									props.onValueChanged(0)
								}}
							>
								{"Chọn hình thức nộp phí"}
							</ActionList.Item>
						}
						{source && source.map((item, index) => {
							return (
								<ActionList.Item key={item.id} selected={props.value != undefined && item.id === props.value}
									onSelect={() => {
										props.onValueChanged(item.id)
									}}
								>
									{item.text}
								</ActionList.Item>
							);
						})}
					</ActionList>
				</ActionMenu.Overlay>
			</ActionMenu>
		</div>
	);
};

export default CmbHinhThucNopPhi;
